export default "__VITE_ASSET__DnRHkURY__"